<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList" 
      :show-back="true"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="参保地区">
                <div class="detail">{{info.communityName}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="姓名">
                <div class="detail">{{info.userName}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="年龄">
                <div class="detail">{{info.age}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="身份证号">
                <div class="detail">{{info.idCardNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="手机号码">
                <div class="detail">{{info.phoneNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="居住地址">
                <div class="detail">{{info.address}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="状态">
                <div
                  class="detail"
                >{{info.statusIndex!=null?statusList[info.statusIndex].status:''}}</div>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="info.statusIndex && statusList[info.statusIndex].index == 4">
              <FormItem label="死亡时间">
                <div class="detail">{{info.deathTime && info.deathTime}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="类别">
                <div class="detail">{{info.typeIndex!=null?typeList[info.typeIndex].type:''}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="最后一次认证时间">
                <div class="detail">{{info.lastFaceVerifyTime}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="最后一次认证结果">
                <div
                  :class="[info.lastFaceVerify ==1?'success':'','detail']"
                >{{info.lastFaceVerify == 11?'人工认证成功': info.lastFaceVerify == null || info.lastFaceVerify ==2? '待认证': info.lastFaceVerify ==1?'认证成功':'认证失败'}}</div>
                <!-- lastFaceVerify 1 人脸认证 2 待认证 11 人工认证  -->
                <!-- statusIndex   0 正常 1 暂停 2 新增 3 待遇终止 4 死亡  -->
              </FormItem>
            </i-col>
          </row>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="照片">
                <!-- <img v-if="info.headPicUrl" class="headPicUrl" :src="info.headPicUrl" /> -->
                <el-image
                  v-if="info.headPicUrl"
                  class="headPicUrl"
                  :preview-src-list="[info.headPicUrl]"
                  :src="info.headPicUrl"
                />
              </FormItem>
            </i-col>
          </row>
        </Form>
        <Modal
          @on-visible-change="onVisibleChange"
          :value="showCheckMsg"
          :title="modalTitle"
          :mask-closable="false"
        >
          <div>是否确定注销 {{info.userName}}</div>
          <div slot="footer">
            <Button style="margin-right:10px" @click="showCheckMsg = false">取消</Button>
            <Button type="primary" @click="confirmDie" :loading="isBtbLoading">确定</Button>
          </div>
        </Modal>
        <Modal
          @on-visible-change="onVisibleChangeRecover"
          :value="showCheckMsgRecover"
          title="恢复此记录"
          :mask-closable="false"
        >
          <div>是否确定恢复 {{info.userName}}</div>
          <div slot="footer">
            <Button style="margin-right:10px" @click="showCheckMsgRecover = false">取消</Button>
            <Button type="primary" @click="confirmRecover" :loading="isBtbLoadingRecover">确定</Button>
          </div>
        </Modal>
        <Modal
          @on-visible-change="onVisibleChange1"
          :value="showCheckMsg1"
          :title="modalTitle1"
          :mask-closable="false"
        >
          <div>请详细确认认证信息</div>
          <div slot="footer">
            <Button style="margin-right:10px" @click="showCheckMsg1 = false">取消</Button>
            <Button type="primary" @click="artificialVerify" :loading="isBtbLoading1">确定</Button>
          </div>
        </Modal>
      </div>
      <div class="table-data">
        <div class="verifyRecord">认证记录</div>
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
        >
          <template slot-scope="{ row, index }" slot="faceVerify">
            <span
              :class="[row.faceVerify?'success':'']"
            >{{row.faceVerify == 11?'人工认证成功':row.faceVerify ?'认证成功':'认证失败'}}</span>
          </template>
        </i-table>
        <div class="page">
          <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { ssDetail, faceVerifyList, artificialVerify, deathConfirm,deathRecover } = api;
export default {
  name: "ssvDetail",
  components: {
    pageHead,
  },
  data() {
    return {
      title: "人员详情",
      showCheckMsg: false,
      modalTitle: "注销此记录",
      isBtbLoading: false,
      showCheckMsg1: false,
      modalTitle1: "认证此记录",
      isBtbLoading1: false,
      showCheckMsgRecover:false,
      isBtbLoadingRecover:false,
      btnList: [],
       btnList1: [
        {
          name: "死亡注销",
          type: "die",
        }
      ],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      info: {},
      tableHeader: [
        {
          title: "序号",
          type: "index",
          // width: 80,
          // align: "center"
        },
        {
          title: "认证时间",
          key: "createTime",
        },
        {
          title: "认证结果",
          slot: "faceVerify",
        },
      ],
      statusList: [
        {
          index: 0,
          status: "正常",
        },
        {
          index: 1,
          status: "暂停",
        },
        {
          index: 2,
          status: "新增",
        },
        {
          index: 3,
          status: "待遇终止",
        },
        {
          index: 4,
          status: "死亡",
        },
      ],
      typeList: [
        {
          index: 0,
          type: "居民",
        },
        {
          index: 1,
          type: "民办教师",
        },
        {
          index: 2,
          type: "居民&民办教师",
        },
        
      ],
      tableData: [],
      isTableLoading: false,
    };
  },
  methods: {
    async artificialVerify() {
      //人工认证
      console.log(artificialVerify);
      try {
        let { id: socialInsuranceId } = this.$route.query;
        this.isBtbLoading1 = true;
        let res = await this.$post(artificialVerify(socialInsuranceId));
        
        if (res.isSucceed) {
          this.$Message.success("人工认证成功");
          this.getDetail();
        } else {
          this.$Message.error("人工认证失败 " + res.message);
        }
      } finally {
        this.showCheckMsg1 = false;
        this.isBtbLoading1 = false;
      }
    },
    handleBtn(type) {
      this.showCheckMsg1 = false;
      this.showCheckMsg = false;
      this.showCheckMsgRecover = false;
      if (type == "artificialVerify") {
        this.showCheckMsg1 = true;
        // this.artificialVerify();
      } else if (type == "die") {
        console.log("die");
        this.showCheckMsg = true;
      }else if(type=='recover'){
         console.log("recover");
        this.showCheckMsgRecover = true;
      }
    },
    onVisibleChange() {},
    onVisibleChange1() {},
    onVisibleChangeRecover(){},
    async confirmRecover() {
      try {
        let { id: socialInsuranceId } = this.$route.query;
        this.isBtbLoadingRecover = true;
        let res = await this.$post(deathRecover(socialInsuranceId));
        if (res.isSucceed) {
          this.$Message.success("恢复记录成功");
          this.getDetail();
        } else {
          this.$Message.error("恢复记录成功 " + res.message);
        }
      } finally {
        this.showCheckMsgRecover = false;
        this.isBtbLoadingRecover = false;
      }
    },
    async confirmDie() {
      try {
        let { id: socialInsuranceId } = this.$route.query;
        this.isBtbLoading = true;
        let res = await this.$post(deathConfirm(socialInsuranceId));
        if (res.isSucceed) {
          this.$Message.success("死亡注销成功");
          this.getDetail();
        } else {
          this.$Message.error("死亡注销失败 " + res.message);
        }
      } finally {
        this.showCheckMsg = false;
        this.isBtbLoading = false;
      }
    },
    pageChange(val) {
      this.pageNum = val;
      this.getFaceList();
    },
    async getDetail() {
      try {
        let { id: socialInsuranceId } = this.$route.query;
        let res = await this.$get(ssDetail(socialInsuranceId));
        if (res.isSucceed && res.rows) {
          this.info = res.rows[0];

          if (this.info.headPicUrl) {
            const lastSlashIndex = this.info.headPicUrl.lastIndexOf('/');
            
            const lastPart = this.info.headPicUrl.slice(lastSlashIndex + 1);

            if (lastPart.length > 30) {
              this.info.headPicUrl = this.info.headPicUrl.replace(/(.{15})(?=.{2}\.[^.]+$)/, '')
            }
          }
          

          if(!this.info.userName){
            this.btnList = []
          }else if(this.info.statusIndex == 4){
            this.btnList = [{
              name: "恢复正常",
              type: "recover",
            }]
          }else{
            let path = this.$store.state.path + ''
            console.log(path)
            let patharr = path.split(',')
            if(patharr.length >4 && path.indexOf('410923000000')>-1){
              //如果是南乐县下的乡，关闭人工认证按钮
              this.btnList =[
                {
                  name: "死亡注销",
                  type: "die",
                },
                
              ]
            }else{
              this.btnList =[
                {
                  name: "死亡注销",
                  type: "die",
                },
                {
                  name: "人工认证",
                  type: "artificialVerify",
                },
              ]
            }
          }
          
          this.getFaceList();
        }
      } finally {
      }
    },
    async getFaceList() {
      try {
        let comeType = 34;
        let allowance =
          this.$route.query.allowance && this.$route.query.allowance == 1;
        console.log("getFaceList", allowance);
        if (allowance) {
          comeType = 37;
        }
        this.isLoading = true;
        let res = await this.$post(faceVerifyList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          comeType: comeType,
          idCardNO: this.info.idCardNO,
        });
        if (res.isSucceed && res.rows) {
          this.tableData = res.rows;
          this.total = res.total;
        }
        console.log(this.tableData);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.detail {
  color: #666;
}
.headPicUrl {
  display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
}
.success {
  color: #ff7b44;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}
</style>